// Our Modal is visually identical to the the Modal in cn-web-components
// https://github.com/ChowNow/cn-web-components/blob/main/src/components/Modals/Modal/Modal.tsx

import React, { useContext } from 'react';

import { ModalContext } from 'context/modal';

import ModalComponents from 'types/modals';

import Alert from 'components/designSystem/Modals/Alert/Alert';
import ModalStandard from 'components/designSystem/Modals/ModalStandard/ModalStandard';
import ModalFrame from 'components/designSystem/Modals/ModalFrame/ModalFrame';

import AuthSharedModal from 'components/shared/Modals/AuthModal/AuthModal';
import LocationLookupFailedModal from 'components/shared/Modals/LocationLookupFailedModal/LocationLookupFailedModal';
import LocationSearchModal from 'components/shared/Modals/LocationSearchModal/LocationSearchModal';
import RatingsSurveyModal from 'components/shared/Modals/RatingsSurveyModal/RatingsSurveyModal';

const MODAL_COMPONENTS = {
  AUTH: AuthSharedModal,
  LOCATION_LOOKUP_FAILED: LocationLookupFailedModal,
  LOCATION_SEARCH: LocationSearchModal,
  RATINGS_SURVEY: RatingsSurveyModal,
};

enum ModalTypes {
  frame = 'frame',
  alert = 'alert',
  default = 'default',
}

import styles from './ModalWrapper.module.scss';
import classNames from 'classnames';

function getModalType(type) {
  switch (type) {
    case ModalTypes.frame:
      return ModalFrame;
    case ModalTypes.alert:
      return Alert;
    default:
      return ModalStandard;
  }
}

const Modal = () => {
  const { modalProps, modalType, hideModal } = useContext(ModalContext);

  const { wrapperClassName: givenWrapperClassName } = modalProps;

  function handleRequestClose() {
    return hideModal();
  }

  if (!modalType) {
    return null;
  }

  // The child modal
  // Should the child modal itself actually import the DS? Or the wrapper?
  // Do we assume that all will be normal?
  // Can we pass some sort of option for frame vs standard?
  const ModalToRender = MODAL_COMPONENTS[modalType];

  // if there is a declared modal style, use it. if not, use the DS
  // This could be clener
  const ModalWrapper = getModalType(modalProps.designSystemModalStyle);
  const wrapperClassName = `${styles.wrapper} ${givenWrapperClassName || ''}`.trim();

  return (
    <>
      <div className={styles.modalOverlay} onClick={handleRequestClose} />
      <ModalWrapper
        shouldShowCloseIcon={modalProps.shouldShowCloseIcon}
        className={classNames(wrapperClassName, { [styles.tall]: modalProps.isTall })}
        centerAlign={modalType === ModalComponents.AUTH}
        isTall={modalProps.isTall}
      >
        <ModalToRender {...modalProps} hideModal={hideModal} />
      </ModalWrapper>
    </>
  );
};

export default Modal;
